<template lang="">
  <div class="product">
    <div
      class="f1"
      :style="{
        backgroundImage: 'url(' + baseUrl + '/shutterstockd.png' + ')',
      }"
    >
      <div class="f1_box">
        <div class="f1_title">PRODUCT</div>
      </div>
    </div>
    <div class="f2 bgf">
      <div class="f2_box">
        <img :src="baseUrl + '/shutterstocke.png'" class="img_left" />
        <div class="f2_bg_left"></div>
        <div class="f2_txt_box">
          <div class="f2_txt_title1">Group saving</div>
          <div class="f2_txt_title2">Partner with Choice Bank</div>
          <div class="f2_txt_content">
            We launch this service partner with Choice Bank. Consumers could save
            together in a group both with their friends or stranger to achieve a
            continuous saving target, normally, it is a daily saving plan last
            for at least 14 days. We will reward consumers by giving them a
            credit to conduct a loan for 3 multiples of their total savings.
            This product is only available in Kenya now.
          </div>
          <button>REGISTER</button>
        </div>
      </div>
    </div>
    <div class="f2 bge">
      <div class="f2_box">
        <div class="f2_txt_box">
          <div class="f2_txt_title1">Group lending</div>
          <div class="f2_txt_title2">Partner with Choice Bank</div>
          <div class="f2_txt_content">
            We launch this service partner with Choice Bank. Consumers can lend
            money by a group, in the group, member will be guarantor for each
            other, which will result in a higher amount of loan and a lower
            interest. This is a 3 months’ product, amount is approximate 3
            multiples of the group savings, based on the other risk calculation
            from our AI engine, and repayment will be conducted bi-weekly. This
            product is only available in Kenya now.
          </div>
          <button>REGISTER</button>
        </div>
        <img :src="baseUrl + '/shutterstocka.png'" class="img_right" />
        <div class="f2_bg_right"></div>
      </div>
    </div>
    <div class="f2 bgf">
      <div class="f2_box">
        <img :src="baseUrl + '/shutterstockg.png'" class="img_left" />
        <div class="f2_bg_left"></div>
        <div class="f2_txt_box">
          <div class="f2_txt_title1">Personal Loan</div>
          <div class="f2_txt_title2">
            Partner with Ralisbank and Choice Bank
          </div>
          <div class="f2_txt_content">
            We launch this product partner with Ralisbank and Choice Bank.
            Consumers can conduct loan from 200 USD. This product is now only
            available in Kenya and Spain.
          </div>
          <button>REGISTER</button>
        </div>
      </div>
    </div>
    <div class="f2 bge">
      <div class="f2_box">
        <div class="f2_txt_box">
          <div class="f2_txt_title1">SaaS</div>
          <div class="f2_txt_content">
            We has developed a SACCO management system that will enable SACCOs
            to achieve their vision, by providing optimization of technology at
            affordable cost.
          </div>
          <button>REGISTER</button>
        </div>
        <img :src="baseUrl + '/shutterstockh.png'" class="img_right" />
        <div class="f2_bg_right"></div>
      </div>
    </div>
    <div class="f3">
      <div class="f3_content">
        Our product has served <br />
        10 million users or more, <br />
        and our AI engine has processed <br />
        at least 1 billion requests accumulated.
      </div>
    </div>
    <div class="f4">
      <div class="f4_box">
        <div class="f4_title">FEATURES</div>
        <div class="f4_list_box">
          <div class="f4_list">
            <img :src="baseUrl + '/shutterstockh.png'" alt="" />
            <!-- <div class="f4_list_title">01.</div> -->
            <div class="f4_list_content">
              AI enabled engine with 25,000 attributes, ensure a 20% lower
              delinquency rate than traditional models.
            </div>
          </div>
          <div class="f4_list">
            <img :src="baseUrl + '/shutterstockb.png'" alt="" />
            <!-- <div class="f4_list_title">02.</div> -->
            <div class="f4_list_content">
              99% of personal loan funds are sent just 1 business day after
              signing.
            </div>
          </div>
          <div class="f4_list">
            <img :src="baseUrl + '/shutterstockf.png'" alt="" />
            <!-- <div class="f4_list_title">03.</div> -->
            <div class="f4_list_content">
              Consumers may pay off part or all of the loan at any time with no
              fee.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="f5">
      <div class="f5_box">
        <div class="f5_title">PARTNERS</div>
        <img :src="baseUrl + '/choice_bank.png'" alt="" class="img1" />
        <img :src="baseUrl + '/ralis_bank.png'" alt="" class="img2" />
        <img :src="baseUrl + '/equifax.png'" alt="" class="img3" />
        <img :src="baseUrl + '/trans_union.png'" alt="" class="img4" />
        <img :src="baseUrl + '/experian.png'" alt="" class="img5" />
        <img :src="baseUrl + '/paystack.png'" alt="" class="img6" />
        <img :src="baseUrl + '/safaricom.png'" alt="" class="img7" />
        <img :src="baseUrl + '/stp.png'" alt="" class="img8" />
      </div>
    </div>
    <!-- <div class="f6">
      <div class="f6_box">
        <div class="f6_title">MANAGEMENT</div>
        <div class="f6_list_box">
          <div class="f6_list">
            <img :src="baseUrl + '/duanwei.png'" />
            <div class="f6_list_title">Robin Duan</div>
            <div class="f6_list_txt">Chairman</div>
          </div>
          <div class="f6_list">
            <img :src="baseUrl + '/duanwei.png'" />
            <div class="f6_list_title">Robin Duan</div>
            <div class="f6_list_txt">Chairman</div>
          </div>
          <div class="f6_list">
            <img :src="baseUrl + '/duanwei.png'" />
            <div class="f6_list_title">Robin Duan</div>
            <div class="f6_list_txt">Chairman</div>
          </div>
          <div class="f6_list">
            <img :src="baseUrl + '/duanwei.png'" />
            <div class="f6_list_title">Robin Duan</div>
            <div class="f6_list_txt">Chairman</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    this.$store.commit("SetStatus", "3");
  },
};
</script>
<style lang="scss" scoped>
.product {
  .f1 {
    width: 100%;
    height: 403px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .f1_box {
      width: 1200px;
      margin: 0 auto;
      .f1_title {
        padding-top: 150px;
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
      }
    }
  }
  .f2 {
    width: 100%;
    padding: 100px 0;
    &.bgf {
      background-color: #fff;
    }
    &.bge {
      background-color: #f6f6fb;
    }
    .f2_box {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      .img_left {
        display: inline-block;
        vertical-align: top;
        margin-right: 140px;
        width: 530px;
        height: 306px;
        position: relative;
        z-index: 1;
      }
      .img_right {
        display: inline-block;
        vertical-align: top;
        margin-left: 140px;
        width: 530px;
        height: 306px;
        position: relative;
        z-index: 1;
      }
      .f2_bg_left {
        width: 530px;
        height: 294px;
        position: absolute;
        left: -28px;
        top: 40px;
        background-color: #f43d3d;
      }
      .f2_bg_right {
        width: 530px;
        height: 294px;
        position: absolute;
        right: -28px;
        top: 40px;
        background-color: #f43d3d;
      }
      .f2_txt_box {
        display: inline-block;
        width: 530px;
        vertical-align: top;
        .f2_txt_title1 {
          font-size: 30px;
          font-family: "oh";
          font-weight: normal;
          color: #f43d3d;
        }
        .f2_txt_title2 {
          font-size: 20px;
          font-family: "ob";
          font-weight: normal;
          color: #28283c;
          margin-top: 10px;
        }
        .f2_txt_content {
          padding-top: 50px;
          font-size: 18px;
          font-family: "or";
          font-weight: normal;
          color: #28283c;
          line-height: 30px;
          position: relative;
          &::before {
            position: absolute;
            left: 0;
            top: 25px;
            content: " ";
            width: 62px;
            height: 2px;
            background-color: #ebebeb;
          }
        }
        button {
          margin-top: 40px;
          display: block;
          width: 153px;
          height: 41px;
          background: #28283c;
          border-radius: 4px;
          border: none;
          outline: none;
          font-size: 18px;
          font-family: "ob";
          font-weight: normal;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
  .f3 {
    width: 100%;
    padding: 130px 0;
    background-color: #fff;
    .f3_content {
      width: 100%;
      text-align: center;
      font-size: 56px;
      font-family: "oh";
      font-weight: normal;
      color: #f43d3d;
      line-height: 88px;
    }
  }
  .f4 {
    width: 100%;
    padding: 80px 0 190px;
    background-color: #28283c;
    .f4_box {
      width: 1200px;
      margin: 0 auto;
      .f4_title {
        text-align: center;
        margin-bottom: 160px;
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
      }
      .f4_list_box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .f4_list {
          width: 340px;
          img {
            width: 340px;
            height: 249px;
            display: block;
          }
          .f4_list_title {
            margin: 48px 0 25px;
            font-size: 30px;
            font-family: "oh";
            font-weight: normal;
            color: #f43d3d;
          }
          .f4_list_content {
            margin-top: 20px;
            font-size: 18px;
            font-family: "or";
            font-weight: normal;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }
  }
  .f5 {
    width: 100%;
    padding: 80px 0 170px;
    background-color: #fff;
    .f5_box {
      width: 1200px;
      margin: 0 auto;
      .f5_title {
        text-align: center;
        margin-bottom: 84px;
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
      }
      .img1 {
        display: inline-block;
        width: 398px;
        height: 150px;
        vertical-align: top;
        margin-right: 124px;
      }
      .img2 {
        display: inline-block;
        width: 258px;
        height: 35px;
        vertical-align: top;
        margin-right: 169px;
        padding: 52px 0 63px;
      }
      .img3 {
        display: inline-block;
        width: 224px;
        height: 44px;
        vertical-align: top;
        padding: 53px 0;
      }
      .img4 {
        display: inline-block;
        width: 226px;
        height: 69px;
        vertical-align: top;
        padding: 10px 0 58px 29px;
        margin-top: 6px;
        margin-left: 84px;
        margin-right: 190px;
      }
      .img5 {
        display: inline-block;
        width: 226px;
        height: 69px;
        vertical-align: top;
        padding: 21px 0 40px;
        margin-top: 6px;
        margin-right: 162px;
      }
      .img6 {
        display: inline-block;
        width: 246px;
        height: 137px;
        vertical-align: top;
        margin-top: 6px;
      }
      .img7 {
        display: inline-block;
        width: 278px;
        height: 78px;
        vertical-align: top;
        margin-top: 44px;
        padding-left: 55px;
        margin-right: 276px;
      }
      .img8 {
        display: inline-block;
        width: 101px;
        height: 67px;
        vertical-align: top;
        margin-top: 44px;
        padding: 7px 0 4px;
      }
    }
  }
  .f6 {
    width: 100%;
    padding: 80px 0 125px;
    background-color: #fff;
    .f6_box {
      width: 1200px;
      margin: 0 auto;
      .f6_title {
        text-align: center;
        margin-bottom: 160px;
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
      }
      .f6_list_box {
        display: flex;
        justify-content: space-between;
        .f6_list {
          width: 258px;
          img {
            display: block;
            width: 258px;
            height: 309px;
          }
          .f6_list_title {
            text-align: center;
            margin: 23px 0 8px;
            font-size: 22px;
            font-family: "oh";
            font-weight: normal;
            color: #f43d3d;
            text-align: center;
          }
          .f6_list_txt {
            height: 14px;
            font-size: 14px;
            font-family: "or";
            font-weight: normal;
            color: #28283c;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
